const config = {
  pageSizeS: 25,
  pageSizeM: 50,
  pageSizeL: 100,
  dlgSizeS: '360px',
  dlgSizeM: '540px',
  dlgSizeL: '720px',

  TAG_TYPE_FORM: 1,
  TAG_TYPE_MEM: 2,
  TAG_TYPE_FILE: 3,
  TAG_TYPE_CONTACT: 4,
  TAG_TYPE_REPLY: 5,
  TAG_TYPE_TPL_INDUSTRY: 6,
  TAG_TYPE_TPL_SCEN: 7,

  ORG_ROLE: [{
    value: '2',
    label: '管理员'
  }, {
    value: '3',
    label: '成员'
  }],
  ORG_ROLE_ADMIN: '2',
  ORG_ROLE_MEMBER: '3',
  getOrderTypeName: function(type) {
    switch (parseInt(type)) {
      case 1:
        return '新购'
      case 2:
        return '续费'
      case 3:
        return '升级'
      case 21:
        return '单项增购'
      default:
        return '-'
    }
  },
  ORDER_ST: ['已作废', '待支付', '已支付'],
  ORDER_ST_COLOR: ['info', 'primary', 'success'],

  priceUrl: `//bahuyun.com`,
  SPU_ID_PROD: 1,
  SPU_ID_SMS: 10001,
  SPU_ID_MEMBER: 20001,
  scenList: [
    { value: 'form', label: '表单', desc: '表单 / 问卷 / 登记 / 报名' },
    { value: 'test', label: '测评', desc: '考试 / 测试 / 测评 / 考评' },
    { value: 'vote', label: '投票', desc: '评选 / 选举 / 投票 / 比赛' },
    { value: 'order', label: '订单', desc: '订单 / 订购 / 收款' },
    { value: 'book', label: '预约', desc: '预约 / 预定' }
  ]
}

export default config
